/* eslint-disable jira/integration/test-id-by-folder-structure */
import React, { useMemo, type ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { Board } from '@atlassian/jira-navigation-apps-sidebar-common/src/types.tsx';
import BaseHeader from '@atlassian/jira-horizontal-nav-header/src/common/ui/BaseHeader.tsx';
import { ShareButton } from '../share-button/index.tsx';
import { HeaderFullscreenButton } from '../fullscreen-button/index.tsx';
import type { UserBoardHeader_board$key } from './__generated__/UserBoardHeader_board.graphql';

type Props = {
	boardFragment: UserBoardHeader_board$key;
};

export const UserBoardHeader = ({ boardFragment }: Props): React.JSX.Element => {
	const boardData = useFragment(
		graphql`
			fragment UserBoardHeader_board on JiraBoard {
				boardId @required(action: THROW)
				name @required(action: THROW)
				boardType @required(action: THROW)
			}
		`,
		boardFragment,
	);

	const extraComponentsFar = useMemo(() => {
		const board: Board = {
			id: boardData.boardId,
			name: boardData.name,
			type: boardData.boardType === 'SCRUM' ? 'scrum' : 'kanban',
			isProjectBoard: false,
		};

		const components: ReactNode[] = [];

		components.push(<HeaderFullscreenButton key="fullscreen" />);
		components.push(<ShareButton key="share" data={board} />);
		return components;
	}, [boardData]);

	return (
		<BaseHeader
			testId="horizontal-nav-header.ui.user-board-header"
			title={boardData.name}
			extraComponentsClose={[]}
			extraComponentsFar={extraComponentsFar}
		/>
	);
};
